import { makeStyles } from '@rbx/ui';

const useOperationDetailsStyles = makeStyles()(() => ({
  root: {
    '& .MuiTypography-root': {
      fontSize: '16px',
      marginBottom: '6px',
      '& .inline-code': {
        fontSize: '14px',
      },
    },
  },
}));

export default useOperationDetailsStyles;
